<!-- Quick stats boxes -->
<div class="row">

    <div class="col-sm-6 col-md-3">
        <div class="panel panel-body">
            <div class="media no-margin-top content-group">
                <div class="media-body">
                    <h6 class="no-margin text-semibold">Balance status</h6>
                    <span class="text-muted">{{analyticsDTO?.total_balance|number:'1.2-2'}} ETB</span>
                </div>

                <div class="media-right media-middle">
                    <i class="icon-pulse2 icon-2x opacity-75"
                        [ngClass]="{'text-warning-400':(this.analyticsDTO?.balance_percentage > 10 && this.analyticsDTO?.balance_percentage <= 20),'text-danger-400':this.analyticsDTO?.balance_percentage > 20 }"></i>
                </div>
            </div>

            <div class="progress progress-micro mb-10">
                <div class="progress-bar"
                    [ngClass]="{'bg-warning-400':(this.analyticsDTO?.balance_percentage > 10 && this.analyticsDTO?.balance_percentage <= 20),'bg-danger-400':this.analyticsDTO?.balance_percentage > 20 }"
                    [ngStyle]="{'width':getBalancePercentage()}">
                    <span class="sr-only">{{analyticsDTO?.balance_percentage}}% Complete</span>
                </div>
            </div>
            <span class="pull-right">{{analyticsDTO?.balance_percentage}}%</span>
            Balance due
        </div>
    </div>

    <div class="col-sm-6 col-md-3">
        <div class="panel panel-body">
            <div class="media no-margin-top content-group">
                <div class="media-body">
                    <h6 class="no-margin text-semibold">Total Ekubs</h6>
                    <span class="text-bold">{{analyticsDTO?.total_ekubs}}</span> - <span
                        class="text-muted">{{analyticsDTO?.total_active_members}} Active Members</span>
                </div>

                <div class="media-right media-middle">
                    <i class="icon-pulse2 icon-2x opacity-75"
                        [ngClass]="{'text-warning-400':(this.analyticsDTO?.lagging_percentage > 10 && this.analyticsDTO?.lagging_percentage < 20),'text-danger-400':this.analyticsDTO?.lagging_percentage >= 20 }"></i>
                </div>
            </div>

            <div class="progress progress-micro mb-10">
                <div class="progress-bar"
                    [ngClass]="{'bg-warning-400':(this.analyticsDTO?.lagging_percentage > 10 && this.analyticsDTO?.lagging_percentage < 20),'bg-danger-400':this.analyticsDTO?.lagging_percentage >= 20 }"
                    [ngStyle]="{'width':getLaggingPercentage()}">
                    <span class="sr-only">{{analyticsDTO?.lagging_percentage}}% Lagging</span>
                </div>
            </div>
            <span class="pull-right"> {{analyticsDTO?.lagging_percentage}}%</span>
            Lagging members - {{analyticsDTO?.total_disqualified_members}}
        </div>
    </div>



    <div class="col-lg-3">

        <!-- Today's revenue -->
        <div class="panel bg-light-400">
            <div class="panel-body">
                <div class="heading-elements">
                    <ul class="icons-list">
                        <li>
                            <a data-action="reload"></a>
                        </li>
                    </ul>
                </div>
                <!-- <strong>Total Sales</strong> -->
                <h6 class="no-margin text-semibold">Total Sales</h6>
                <div class="text-size-small"><span class="text-bold">{{analyticsDTO?.total_sales?.count}}</span> - <span
                        class="text-mute">Estimated value - {{analyticsDTO?.total_sales?.value|number:'1.2-2'}}
                        ETB</span></div>

                <h6 class="no-margin text-semibold" style="padding-top:12px;">Pending Sales</h6>
                <div class="text-size-small"><span class="text-bold">{{analyticsDTO?.pending_sales?.count}}</span> -
                    <span class="">Estimated value - {{analyticsDTO?.pending_sales?.value|number:'1.2-2'}} ETB</span>
                </div>

            </div>

            <div id="today-revenue"></div>
        </div>
        <!-- /today's revenue -->

    </div>

    <div class="col-lg-3">

        <!-- Today's revenue -->
        <div class="panel bg-light-400">
            <div class="panel-body">
                <div class="heading-elements">
                    <ul class="icons-list">
                        <li>
                            <a data-action="reload"></a>
                        </li>
                    </ul>
                </div>

                <h6 class="no-margin text-semibold">Awards Granted</h6>
                <div class="text-size-small"><span class="text-bold">{{analyticsDTO?.awards_granted?.count}}</span> -
                    <span class="">Estimated value - {{analyticsDTO?.awards_granted?.value|number:'1.2-2'}} ETB</span>
                </div>

                <h6 class="no-margin text-semibold" style="padding-top:12px;">Awards Pending</h6>
                <div class="text-size-small"><span class="text-bold">{{analyticsDTO?.awards_pending?.count}}</span> -
                    <span class="">Estimated value - {{analyticsDTO?.awards_pending?.value|number:'1.2-2'}} ETB</span>
                </div>

            </div>

            <div id="today-revenue"></div>
        </div>
        <!-- /today's revenue -->

    </div>

</div>
<!-- /quick stats boxes -->

<div class="row">

    <div class="col-md-8">

        <!-- Marketing campaigns -->
        <div class="panel panel-flat">


            <div class="tabbable">
                <ul class="nav nav-tabs nav-tabs-highlight">
                    <li class="active"><a href="#analytics-tab" data-toggle="tab"> <i
                                class="icon-brain position-left"></i>Ekubs Analytics</a></li>
                    <li><a href="#transactions-tab" data-toggle="tab"> <i
                                class="icon-stats-bars3 position-left"></i>Transactions Statistics</a></li>
                </ul>

                <div class="tab-content">
                    <div class="tab-pane active" id="analytics-tab">

                        <!--  <div class="row">
            
                            <div class="col-md-4">
            
                                <div class="sidebar-category">
                                    <div class="category-title">
                                        <span>Completeness stats</span>
                                        <ul class="icons-list">
                                            <li><a href="#" data-action="collapse"></a></li>
                                        </ul>
                                    </div>
            
                                    <div class="category-content">
                                        <ul class="progress-list">
                                            <li>
                                                <label>Highest priority <span>80%</span></label>
                                                <div class="progress progress-xxs">
                                                    <div class="progress-bar progress-bar-danger" style="width: 80%">
                                                        <span class="sr-only">80% Complete</span>
                                                    </div>
                                                </div>
                                            </li>
                                            <li>
                                                <label>High priority <span>70%</span></label>
                                                <div class="progress progress-xxs">
                                                    <div class="progress-bar progress-bar-info" style="width: 70%">
                                                        <span class="sr-only">70% Complete</span>
                                                    </div>
                                                </div>
                                            </li>
                                            <li>
                                                <label>Normal priority <span>50%</span></label>
                                                <div class="progress progress-xxs">
                                                    <div class="progress-bar progress-bar-primary" style="width: 50%">
                                                        <span class="sr-only">50% Complete</span>
                                                    </div>
                                                </div>
                                            </li>
                                            <li>
                                                <label>Low prioruty <span>60%</span></label>
                                                <div class="progress progress-xxs">
                                                    <div class="progress-bar progress-bar-success" style="width: 60%">
                                                        <span class="sr-only">60% Complete</span>
                                                    </div>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
            
                        </div> -->


                        <div class="panel-heading">
                            <!-- <h6 class="panel-title">Ekubs</h6>
                            <div class="heading-elements">
                                <ul class="icons-list">
                                    <li><a data-action="collapse"></a></li>
                                    <li><a data-action="reload"></a></li>
                                    <li><a data-action="close"></a></li>
                                </ul>
                            </div> -->
                            <div class="row">
                                <div class="col-md-2 form-group required">
                                    <span style="float:left" class="control-label">Filter by status: </span>
                                    <select name="status" required [(ngModel)]="filter"
                                        (ngModelChange)="getAnalyticsFilter(filter)" class="form-control">
                                        <option selected disabled>Status</option>
                                        <option value="">All</option>
                                        <option value="&status=uptodate">Up-to-date</option>
                                        <option value="&status=lagging">Lagging</option>
                                        <option value="&status=terminated">Terminated</option>
                                    </select>
                                </div>

                                <div class="col-md-3 form-group required">
                                    <span class="control-label">&nbsp; </span>
                                </div>
                            </div>
                        </div>

                        <div class="table-responsive">
                            <table class="table table-striped text-nowrap table-customers">
                                <thead>
                                    <tr>
                                        <th>Ekub</th>
                                        <th>Members</th>
                                        <th>Round</th>
                                        <th>Start Date</th>
                                        <th>End Date</th>
                                        <th>Balance</th>
                                        <!-- <th>Value</th> -->
                                        <th>Actions</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let ekub of analyticsDTO?.ekubs">
                                        <td>
                                            <div class="media">
                                                <div class="media-body media-middle">
                                                    <a [routerLink]="['/ekubAnalytics',ekub.id]" class="text-semibold">
                                                        {{ekub?.ekub_id}}</a>
                                                    <div class="text-muted text-size-small">
                                                        {{ekub.amount}} ETB / {{ekub?.interval}}
                                                    </div>
                                                </div>
                                            </div>
                                        </td>
                                        <th>{{ekub?.total_members}}</th>
                                        <td>{{ekub?.current_round}}</td>
                                        <td>{{ekub?.start_date|date:short}}</td>
                                        <td>{{ekub?.end_date|date:short}}</td>
                                        <td>
                                            <ul class="list list-unstyled no-margin">
                                                <li class="no-margin">
                                                    <i
                                                        class="icon-checkmark3 text-size-base text-success position-left"></i>
                                                    Due:
                                                    <a href="#">{{ekub?.ekub_balance_due|number:'1.2-2'}} ETB</a>
                                                </li>
                                                <li class="no-margin">
                                                    <i class="text-size-base position-left"
                                                        [ngClass]="{'text-success-400 icon-checkmark3':(ekub?.ekub_balance >=ekub?.ekub_balance_due),'text-warning icon-cross2':(ekub?.ekub_balance < ekub?.ekub_balance_due)}"></i>
                                                    Balance:
                                                    <a href="#">{{ekub?.ekub_balance|number:'1.2-2'}} ETB</a>
                                                </li>


                                            </ul>
                                        </td>
                                        <!-- <td>
                                            <h6 class="no-margin text-semibold">322.00 ETB</h6>
                                        </td> -->
                                        <td class="text-right">
                                            <ul class="icons-list">
                                                <li class="dropdown">
                                                    <a href="#" class="dropdown-toggle" data-toggle="dropdown">
                                                        <i class="icon-menu7"></i>
                                                        <span class="caret"></span>
                                                    </a>

                                                    <ul class="dropdown-menu dropdown-menu-right">
                                                        <li><a href="#"><i class="icon-file-pdf"></i>
                                                                Invoices</a>
                                                        </li>
                                                        <li><a href="#"><i class="icon-cube2"></i> Shipping
                                                                details</a></li>
                                                        <li><a href="#"><i class="icon-credit-card"></i> Billing
                                                                details</a>
                                                        </li>
                                                        <li class="divider"></li>
                                                        <li><a href="#"><i class="icon-warning2"></i> Report
                                                                problem</a>
                                                        </li>
                                                    </ul>
                                                </li>
                                            </ul>
                                        </td>
                                        <td class="no-padding-left"></td>
                                    </tr>

                                </tbody>
                            </table>
                        </div>


                    </div>

                    <div class="tab-pane has-padding" id="transactions-tab">



                        <fusioncharts [chartConfig]=chartConfig2 [dataSource]=dataSource2>
                        </fusioncharts>



                    </div>

                </div>
            </div>





        </div>
        <!-- /marketing campaigns -->


    </div>

    <div class="col-md-4">

        <div class="panel panel-body overflow-hidden">
            <div class="text-center">
                <fusioncharts [chartConfig]=chartConfig [dataSource]='pieDataSource'>
                </fusioncharts>
            </div>

            <h4 class="custom-title">Top Lagging Ekubs</h4>
            <hr>

            <table class="table table-striped text-nowrap table-customers">
                <thead>
                    <tr>
                        <th>Ekub</th>
                        <th>Members</th>
                        <th>Amount</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let lagging of analyticsDTO?.lagging">
                        <td>
                            <div class="media">


                                <div class="media-body media-middle">
                                    <a href="user_pages_profile_tabbed.html"
                                        class="text-semibold">{{lagging?.ekub_id}}</a>
                                    <div class="text-muted text-size-small">
                                        Latest depsit: Oct 21 2022
                                    </div>
                                </div>
                            </div>
                        </td>
                        <td>
                            <ul class="list list-unstyled no-margin">
                                <li class="no-margin">
                                    <i class="icon-checkmark3 text-size-base text-success position-left"></i>

                                    <a href="#"> {{lagging?.qualified_members}} Members</a>
                                </li>

                                <li class="no-margin">
                                    <i class="icon-cross2 text-size-base text-warning position-left"></i>
                                    <a href="#"> {{lagging?.disqualified_members}} members</a>
                                </li>
                            </ul>
                        </td>
                        <td class="text-left">
                            <ul class="list list-unstyled no-margin">
                                <li class="no-margin">
                                    <i class="icon-checkmark3 text-size-base text-success position-left"></i>
                                    <a href="#"> {{lagging?.ekub_balance_due|number:'1.2-2'}} ETB</a>
                                </li>
                                <li class="no-margin">
                                    <i class="text-size-base position-left"
                                        [ngClass]="{'text-success-400 icon-checkmark3':(lagging?.ekub_balance >= lagging?.ekub_balance_due),'text-warning icon-cross2':(lagging?.ekub_balance < lagging?.ekub_balance_due)}"></i>
                                    <a href="#"> {{lagging?.ekub_balance|number:'1.2-2'}} ETB</a>
                                </li>
                            </ul>
                        </td>
                        <td class="no-padding-left"></td>
                    </tr>

                </tbody>
            </table>


        </div>

    </div>
</div>